import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import getTheme from './base';
import AjaxHelper from '../common/AjaxHelper';

const CustomThemeProvider = (props) => {
	const [themeName, setThemeName] = useState('light');
	useEffect(() => {
		(async () => {
			const screenDesign = await AjaxHelper.invokeServerAPIPromise('/api/screenDesign', {
				screenName: 'Theme'
			});
			if (screenDesign && screenDesign.theme) {
				setThemeName(screenDesign.theme);
			}
		})();
	}, []);

	const { children } = props;

	return (
		<ThemeProvider theme={getTheme(themeName)}>{children}</ThemeProvider>
	);
};

export default CustomThemeProvider;
